import React, { useEffect } from 'react';

import { useIntlSnackbar } from '../../lib/hooks/use-intl-snackbar';
import { usePlayerReportCard } from '../../lib/services/report-card-access.service';
import { ReportCardActions } from './report-card-actions.component';
import { ReportCardActionsButton } from './report-card-actions-button.component';
import { useReportCardActionsContext } from './report-card-actions.context';

interface ILoadedReportCardActionsProps {
  playerAssessmentId: string;
  onFailed: () => void;
}

// Loads one player's contacts and links, then opens their report card menu. A failed load says so and hands
// the row back its trigger to try again; the query hook logs the error itself.
export const LoadedReportCardActions: React.FC<ILoadedReportCardActionsProps> = ({ playerAssessmentId, onFailed }) => {
  const { messages } = useReportCardActionsContext();
  const showSnackbar = useIntlSnackbar();
  const { playerAssessment, error } = usePlayerReportCard(playerAssessmentId);
  const failed = Boolean(error) && !playerAssessment;

  useEffect(() => {
    if (!failed) return;
    showSnackbar(messages.errActionsNotLoaded);
    onFailed();
  }, [failed, showSnackbar, messages, onFailed]);

  if (playerAssessment) return <ReportCardActions playerAssessment={playerAssessment} openOnMount />;

  return <ReportCardActionsButton playerAssessmentId={playerAssessmentId} busy />;
};
